"use strict";

import Page from "./AddVenue.jsx";

export const auth = true;
export const Component = Page;
